// extracted by mini-css-extract-plugin
module.exports = {"notificationRow":"NotificationsRow-module_notificationRow_3T0Xg","bubble":"NotificationsRow-module_bubble_25JlM"};